import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { ProductType } from '../../../../models/product.model';

@Component({
  selector: 'app-layout-basic',
  templateUrl: './layout-basic.component.html',
  styleUrls: ['./layout-basic.component.scss']
})
export class LayoutBasicComponent {

  // protected readonly window = window;

  constructor(
      private _router: Router,
      @Inject(PLATFORM_ID) private platformId: Object
  ) {
  }

  public goToUrl(url:string):void {
    if (isPlatformBrowser(this.platformId)) {
      window.open(url, '_blank');
    }
  }

  public goToOrderForm(productType:ProductType): void {
    this._router.navigate(['order', productType.toLowerCase()])
  }
}
